export const environment = {
  production: true,
  scopeUri: ["api://02f75c23-f396-460d-a369-e3beb3345c99/UserLogin"],
  tenantId: "d41caaa9-a41a-4e0f-9bf6-05cd1f48d271",
  clientId: "bc3a1f7e-1f90-49d2-86fb-5e2061f9f452",
  redirectUrl: "https://systemoversikt.bergen.kommune.no/",
  logoutUrl: "https://systemoversikt.bergen.kommune.no/",
  postLogoutRedirectUrl: "https://www.bergen.kommune.no"
};
